export default "__VITE_ASSET__C0ab7gIG__"